/**
 * Pre-compiled en messages for Select
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { clearSelection: `Clear selection` };
